<template>
    <div class="SocietyDashRequestContainer shadow" v-on:click="$emit('onClick', matchRequest)">
        <div class="SocietyDashRequestContainer-img">
            <div v-bind:style="{
            backgroundColor : `${requestStatuses[matchRequest.status].color}`
            }"
                 class="SocietyDashRequestContainer-img-wrapper"></div>
            <i class="fi" v-bind:class="requestStatuses[matchRequest.status].icon"></i>
        </div>
        <div class="SocietyDashRequestContainer-info">
            <div class="text-uppercase">
                {{matchRequest.match.opponent}} <small class="text-primary">{{competition}}</small>
            </div>
            <div class="text-uppercase">Data: {{matchRequest.match.date | date}}</div>
            <div class="text-uppercase my-1">
                <b-badge :variant="requestStatuses[matchRequest.status].variant" class="text-uppercase px-2 py-1">
                    {{requestStatuses[matchRequest.status].label}}
                </b-badge>
            </div>
            <div class="text-uppercase small text-truncate">
                Pagamento: {{matchRequest.amount | currency}} [ {{matchRequest.payment_method}} ]
                </div>
            <inter-button class="mt-2"
                    size="small"
                    :label="labelButton"
                    @onClick="$emit('onSelect', matchRequest.match)">
            </inter-button>
        </div>
    </div>
</template>

<script>

    import MatchRequest from '@/models/MatchRequest';
    import Utils from '@/utils';
    import InterButton from "../../../../components/form/inter-button/InterButton";

    export default {
        name: "SocietyDashRequestContainer",
        components: {InterButton},
        data() {
            return {
                requestStatuses: Utils.getRequestStatuses()
            }
        },
        props: {
            matchRequest: {
                type: Object,
                default: () => Object.assign({}, MatchRequest)
            },
        },
        computed: {
            labelButton: function() {
                switch(this.matchRequest.status) {
                    case 'completed':
                        return 'SCARICA BIGLIETTI';
                    case 'pending':
                        return 'MODIFICA';
                    default:
                        return 'VISUALIZZA';
                }
            },
            competition: function() {
                if(this.matchRequest
                    && this.matchRequest.match
                    && this.matchRequest.match.archivioPartita
                    && this.matchRequest.match.archivioPartita.competition ) {
                    return this.matchRequest.match.archivioPartita.competition.name;
                } else {
                    return '';
                }
            }
        },

    }
</script>

<style scoped>

</style>
